<template>
    <span class="font12px">
        <span class="mr6" :class="[isView?'text-color-gray not-allowed':'text-color-primary pointer']" @click="checkAllChange(true)">全选</span>/<span class="ml6" :class="[isView?'text-color-gray not-allowed':'text-color-primary pointer']" @click="checkAllChange(false)">取消</span>
    </span>
</template>

<script>
    export default {
        name: "CheckAllBtn",
        props:{
            data:{
                type: Object,
                default: function () {
                    return {}
                }
            },
            isView:Boolean,
        },
        methods:{
            checkAllChange(val){
                if(this.isView) return;
                this.$emit('change',this.data,val);
            },
        }
    }
</script>

<style lang="scss" scoped>
    .not-allowed{
        cursor: not-allowed;
    }

</style>
